function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ListingType, ListingTypeNames, ResidentialListingTypeNames, SaleListingTypeNames, RentListingTypeNames } from '@domain-group/fe-allhomes-library/lib/node';
import objectValues from '../utils/values';
var DEVELOPMENTS_RESIDENTIAL = ListingType.DEVELOPMENTS_RESIDENTIAL.name;
var slugify = name => name.toLowerCase();
var buildFilterType = (name, urlSlug) => ({
  name,
  urlSlug: urlSlug || slugify(name),
  listingTypes: ListingTypeNames
});
var allExceptBusiness = () => ({
  listingTypes: [ListingType.SALES_RESIDENTIAL.name, ListingType.SHARE_RESIDENTIAL.name, ListingType.DEVELOPMENTS_RESIDENTIAL.name, ...RentListingTypeNames]
});
var FilterType = {
  listedDate: buildFilterType('listedDate'),
  propertyTypes: _objectSpread(_objectSpread({}, buildFilterType('propertyTypes')), allExceptBusiness()),
  price: buildFilterType('price'),
  onlyWithPrice: _objectSpread(_objectSpread({}, buildFilterType('onlyWithPrice', 'withprice')), {}, {
    listingTypes: [...SaleListingTypeNames, DEVELOPMENTS_RESIDENTIAL]
  }),
  beds: _objectSpread(_objectSpread({}, buildFilterType('beds')), {}, {
    listingTypes: [...ResidentialListingTypeNames, DEVELOPMENTS_RESIDENTIAL]
  }),
  baths: _objectSpread(_objectSpread({}, buildFilterType('baths')), {}, {
    listingTypes: [...ResidentialListingTypeNames, DEVELOPMENTS_RESIDENTIAL]
  }),
  parking: _objectSpread(_objectSpread({}, buildFilterType('parking')), {}, {
    listingTypes: [...ResidentialListingTypeNames, DEVELOPMENTS_RESIDENTIAL]
  }),
  floorArea: _objectSpread(_objectSpread({}, buildFilterType('floorArea')), allExceptBusiness()),
  blockSize: buildFilterType('blockSize'),
  keywords: buildFilterType('keywords'),
  propertyStatus: _objectSpread(_objectSpread({}, buildFilterType('propertyStatus', 'status')), {}, {
    listingTypes: [...SaleListingTypeNames, ...RentListingTypeNames, DEVELOPMENTS_RESIDENTIAL]
  }),
  saleMethods: _objectSpread(_objectSpread({}, buildFilterType('saleMethods', 'methods')), {}, {
    listingTypes: [...SaleListingTypeNames, DEVELOPMENTS_RESIDENTIAL]
  }),
  listedPropertyTypes: _objectSpread(_objectSpread({}, buildFilterType('listedPropertyTypes', 'listingtypes')), {}, {
    listingTypes: ListingType.RENTAL_RESIDENTIAL.name
  }),
  availability: _objectSpread(_objectSpread({}, buildFilterType('availability')), {}, {
    listingTypes: [...RentListingTypeNames, ListingType.SHARE_RESIDENTIAL.name]
  }),
  listingFeatures: _objectSpread(_objectSpread({}, buildFilterType('listingFeatures')), allExceptBusiness()),
  badges: {
    name: 'badges',
    listingTypes: ListingTypeNames
  },
  onlyWithEvents: buildFilterType('onlyWithEvents', 'withevents')
};
var filterTypesForListingType = listingTypeName => objectValues(FilterType).filter(each => each.listingTypes.includes(listingTypeName)).map(each => each.name);
export default FilterType;
export { filterTypesForListingType };